import {useSelector} from "react-redux";

export const useSelectChatPagination = () => {
  return useSelector(({chats: {chatsPagination}}) => ({
    chatsPagination,
  }));
}
